const IGNORED = ['a', 'e', 'o', 'os', 'da', 'das', 'de', 'di', 'do', 'dos'];

export function capitalize(words) {
  return words.map((word, index) => {
    if (index && IGNORED.includes(word)) {
      return word;
    }

    return word[0].toUpperCase() + word.slice(1);
  });
}

export default function namelize(value, limit) {
  if (!value || typeof value !== 'string') {
    return '';
  }

  let words = value.toLowerCase().replace(/ +/g, ' ').trim().split(' ');

  if (limit) {
    let index = limit;

    if (IGNORED.includes(words[index - 1])) {
      index += 1;
    }

    words = words.slice(0, index);
  }

  return capitalize(words).join(' ');
}
